import { SubTypeOption } from "../api/gms/group-category/group-category-api-state";
import { GcliRateGroup, RateGroup, SubOptionList } from "../features/actuarial/rates-state";

export const ratesList: SubTypeOption[] = [
    { id: 1, name: "1 month" },
    { id: 2, name: "2 months" },
    { id: 3, name: "3 months" },
    { id: 4, name: "4 months" },
    { id: 5, name: "5 months" },
    { id: 6, name: "6 months" },
    { id: 7, name: "7 months" },
    { id: 8, name: "8 months" },
    { id: 9, name: "9 months" },
    { id: 10, name: "10 months" },
    { id: 11, name: "11 months" },
    { id: 12, name: "12 months" },
    { id: 13, name: "13 months" },
    { id: 14, name: "14 months" },
    { id: 15, name: "15 months" },
    { id: 16, name: "16 months" },
    { id: 17, name: "17 months" },
    { id: 18, name: "18 months" },
    { id: 19, name: "19 months" },
    { id: 20, name: "20 months" },
    { id: 21, name: "21 months" },
    { id: 22, name: "22 months" },
    { id: 23, name: "23 months" },
    { id: 24, name: "24 months" },
    { id: 25, name: "25 months" },
    { id: 26, name: "26 months" },
    { id: 27, name: "27 months" },
    { id: 28, name: "28 months" },
    { id: 29, name: "29 months" },
    { id: 30, name: "30 months" },
    { id: 31, name: "31 months" },
    { id: 32, name: "32 months" },
    { id: 33, name: "33 months" },
    { id: 34, name: "34 months" },
    { id: 35, name: "35 months" },
    { id: 36, name: "36 months" },
    { id: 37, name: "37 months" },
    { id: 38, name: "38 months" },
    { id: 39, name: "39 months" },
    { id: 40, name: "40 months" },
    { id: 41, name: "41 months" },
    { id: 42, name: "42 months" },
    { id: 43, name: "43 months" },
    { id: 44, name: "44 months" },
    { id: 45, name: "45 months" },
    { id: 46, name: "46 months" },
    { id: 47, name: "47 months" },
    { id: 48, name: "48 months" },
    { id: 49, name: "49 months" },
    { id: 50, name: "50 months" },
    { id: 51, name: "51 months" },
    { id: 52, name: "52 months" },
    { id: 53, name: "53 months" },
    { id: 54, name: "54 months" },
    { id: 55, name: "55 months" },
    { id: 56, name: "56 months" },
    { id: 57, name: "57 months" },
    { id: 58, name: "58 months" },
    { id: 59, name: "59 months" },
    { id: 60, name: "60 months" },
];

export const evidenceOfInsurability: SubOptionList[] = [
    { id: 1, name: "NEL", isCheck: false },
    { id: 2, name: "NML", isCheck: false }
]

export const gcliRates6670InitialState: GcliRateGroup[] = [
    {
        title: "66",
        data: [],
    },
    {
        title: "67",
        data: [],
    },
    {
        title: "68",
        data: [],
    },
    {
        title: "69",
        data: [],
    },
    {
        title: "70",
        data: [],
    },
];

export const gcliRates7175InitialState: GcliRateGroup[] = [
    {
        title: "71",
        data: [],
    },
    {
        title: "72",
        data: [],
    },
    {
        title: "73",
        data: [],
    },
    {
        title: "74",
        data: [],
    },
    {
        title: "75",
        data: [],
    },
];

export const gcliRates7680InitialState: GcliRateGroup[] = [
    {
        title: "76",
        data: [],
    },
    {
        title: "77",
        data: [],
    },
    {
        title: "78",
        data: [],
    },
    {
        title: "79",
        data: [],
    },
    {
        title: "80",
        data: [],
    },
];


export const defaultRateOf1865Fix: RateGroup[] = [
    { title: "18-65", data: [] },
]

export const defaultRateOf1865Dynamic: RateGroup[] = [
    { title: "18 to 65", data: [] },
    { title: "18 to 24", data: [] },
    { title: "25 to 29", data: [] },
    { title: "30 to 34", data: [] },
    { title: "35", data: [] },
    { title: "36", data: [] },
    { title: "37", data: [] },
    { title: "38", data: [] },
    { title: "39", data: [] },
    { title: "40", data: [] },
    { title: "41", data: [] },
    { title: "42", data: [] },
    { title: "43", data: [] },
    { title: "44", data: [] },
    { title: "45", data: [] },
    { title: "46", data: [] },
    { title: "47", data: [] },
    { title: "48", data: [] },
    { title: "49", data: [] },
    { title: "50", data: [] },
    { title: "51", data: [] },
    { title: "52", data: [] },
    { title: "53", data: [] },
    { title: "54", data: [] },
    { title: "55", data: [] },
    { title: "56", data: [] },
    { title: "57", data: [] },
    { title: "58", data: [] },
    { title: "59", data: [] },
    { title: "60", data: [] },
    { title: "61", data: [] },
    { title: "62", data: [] },
    { title: "63", data: [] },
    { title: "64", data: [] },
    { title: "65", data: [] },
];